export default __webpack_public_path__ + "static/wand-education_small-image_4-29d9df7b9507ca32578c43b86fd0db79.webp";